import React, { Component } from 'react';
import PropTypes from "prop-types";
import { GrantsTable } from '../../style';

export default class RecentCharities extends Component {
  render() {
    return (
      <div>
        <GrantsTable
          className="main"
          columns={this.props.column}
          dataSource={this.props.data}
          pagination={false}
        />
      </div>
    )
  }
}

RecentCharities.propTypes = {
  column: PropTypes.array,
  data: PropTypes.array,
}
